import styled from '@emotion/styled';
import User from '../../../../entity/User';
import { Button as _Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import ExitToApp from '@material-ui/icons/ExitToApp';
// import Settings from '@material-ui/icons/Settings';
import { ClassAttributes, Component, createElement, MouseEvent, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';
import AvatarAndName from '../../compound/AvatarAndName';
import { SPACING_LARGE, SPACING_UNIT } from '../../../constant/spacing';
import AccountCircle from '@material-ui/icons/AccountCircle';

interface Props {
  signedInUser: User;
  onClickSignOut: MouseEventHandler<HTMLElement>;
  onClickAccountSettings: MouseEventHandler<HTMLElement>;
  className?: string;
}

interface State {
  open: boolean;
  anchorEl: HTMLElement | undefined;
}

const initialState = {
  open: false,
  anchorEl: undefined,
};

class UserMenu extends Component<ClassAttributes<HTMLElement> & Props, State> {
  state = initialState;

  render() {
    const { signedInUser, className } = this.props;

    return (
      <div className={className}>
        <Button size="small" onClick={this.onClickMenu}>
          <AvatarAndName
            user={signedInUser}
            variant="body2"
            size={32}
            aria-owns={this.state.open ? 'menu-appbar' : null}
            aria-haspopup="true"
            isHorizontal={true}
          />
        </Button>

        <StyledMenu
          id="menu-appbar"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.open}
          onClose={this.onRequestClose}
        >
          <MenuItem button onClick={this.onClickAccountSettings}>
            <ListItemIcon>
              <AccountCircle />
            </ListItemIcon>

            <ListItemText primary={<FormattedMessage id="headbar.account_settings" />} />
          </MenuItem>

          <MenuItem button onClick={this.onClickSignOut}>
            <ListItemIcon>
              <ExitToApp />
            </ListItemIcon>

            <ListItemText primary={<FormattedMessage id="headbar.sign_out" />} />
          </MenuItem>
        </StyledMenu>
      </div>
    );
  }

  private onClickMenu = (e: MouseEvent<HTMLElement>) => {
    this.setState({ open: true, anchorEl: e.currentTarget });
  };

  private onRequestClose = () => {
    this.setState({ open: false });
  };

  private onClickAccountSettings = (e: MouseEvent<HTMLElement>) => {
    this.props.onClickAccountSettings(e);
    this.setState({ open: false });
  };

  private onClickSignOut = (e: MouseEvent<HTMLElement>) => {
    this.props.onClickSignOut(e);
    this.setState({ open: false });
  };
}

const Button = styled(_Button)({
  padding: SPACING_UNIT / 2,
  textTransform: 'none',
}) as typeof _Button;

const StyledMenu = styled(Menu)({
  marginTop: SPACING_LARGE,
}) as typeof Menu;

export default UserMenu;
